import React, { useEffect } from "react";
import TermService from "./TermService";
import styles from "./TermsModal.module.css";

const TermsModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        aria-describedby="terms-modal-description"
        onClick={(event) => event.stopPropagation()}
      >
        <header className={styles.header}>
          <div className={styles.headerText}>
            <h2 id="terms-modal-title" className={styles.headerTitle}>
              Terms & Conditions
            </h2>
            <p id="terms-modal-description" className={styles.headerSubtitle}>
              Tap a section below to jump, or scroll to read.
            </p>
          </div>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close terms and conditions"
          >
            Close
          </button>
        </header>

        <div className={styles.bodyWrap}>
          <div className={styles.body}>
            <TermService inModal />
          </div>
          <div className={styles.scrollHint} aria-hidden="true" />
        </div>

        <footer className={styles.footer}>
          <button
            type="button"
            className={styles.footerButton}
            onClick={onClose}
          >
            Close
          </button>
        </footer>
      </div>
    </div>
  );
};

export default TermsModal;
